import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-market_x",
  "use": "icon-market_x-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-market_x\">\n<path d=\"M5.27992 1.91992C3.42424 1.91992 1.91992 3.42424 1.91992 5.27992V18.7199C1.91992 20.5756 3.42424 22.0799 5.27992 22.0799H18.7199C20.5756 22.0799 22.0799 20.5756 22.0799 18.7199V5.27992C22.0799 3.42424 20.5756 1.91992 18.7199 1.91992H5.27992ZM6.28117 6.23992H10.0912L12.7968 10.0846L16.0799 6.23992H17.2799L13.3387 10.8543L18.1987 17.7599H14.3896L11.2499 13.2993L7.43992 17.7599H6.23992L10.708 12.5296L6.28117 6.23992ZM8.11867 7.19992L14.8902 16.7999H16.3612L9.58961 7.19992H8.11867Z\" fill=\"black\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.28117 6.23992H10.0912L12.7968 10.0846L16.0799 6.23992H17.2799L13.3387 10.8543L18.1987 17.7599H14.3896L11.2499 13.2993L7.43992 17.7599H6.23992L10.708 12.5296L6.28117 6.23992ZM14.8902 16.7999L8.11867 7.19992H9.58961L16.3612 16.7999H14.8902Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/market_x.svg
// module id = sWGE
// module chunks = 262